const f = (e, r, n, t) => r === null ? !1 : t ? t(e, r) : r === n(e);
export {
  f as isOptionSelected
};
